import React from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { logInByGmail } from "../../redux/actions/authActions/authAction";
import { toast } from "react-toastify";

const GoogleButton = () => {
  const dispatch = useDispatch();
  const handleLogin = async (googleData) => {
    dispatch(logInByGmail(googleData));
  };

  const handleError = async (err) => {
    toast.error(err.message, {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      handleLogin(tokenResponse);
    },

    onError: (err) => handleError(err),
  });

  return (
    <div style={{ textAlign: "center" }}>
      <button
        className="login-with-google-btn"
        onClick={googleLogin}
        type="button"
      >
        Sign in with Google
      </button>
    </div>
  );
};

const GoogleAuth = () => {
  const clientId = process.env.REACT_APP_CLIENT_ID;
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleButton />
    </GoogleOAuthProvider>
  );
};

export default GoogleAuth;
